import GameContainer from 'components/Game/GameContainer'
import GamePresentation from 'components/Game/GamePresentation'
import GameData from 'components/Game/GameData'

export default {
  Container: GameContainer,
  Presentation: GamePresentation,
  Data: GameData,
}
